<footer class="fluid-container bg-white">
  <div class="row footer-post-login">
    <div class="col px-0">
      <div class="footer-container">
        <div
          *ngIf="GlobalConstants.client !== 'mastercard'"
          class="footer-link-color links"
        >
          © {{ current_year }} |
          <a
            i18n
            [href]="'/' + locale + '/info/privacy-policy'"
            target="_blank"
            rel="noreferrer noopener"
            class="footer-link-color"
          >
            Privacy Policy
          </a>
          |
          <a
            i18n
            [href]="'/' + locale + '/info/terms-and-conditions'"
            target="_blank"
            rel="noreferrer noopener"
            class="footer-link-color"
          >
            Terms & Conditions
          </a>
          |
          <a
            i18n
            [href]="'/' + locale + '/info/customer-support'"
            target="_blank"
            rel="noreferrer noopener"
            class="footer-link-color"
          >
            Customer Support
          </a>
        </div>
        <div class="best-viewed hide-on-mobile f300" i18n>
          Site best viewed in browsers Mozilla 3.5+, Chrome 3.0+, Safari 5.0+ on
          all desktops, laptops, and Android &amp; iOS mobile/tablet devices.
        </div>
        <div class="powered-by flex align-items-center justify-content-center">
          <span
            i18n
            class="fnt-10 mar-right-5 mar-top-3"
            style="color: #b5b8b7"
          >
            POWERED BY
          </span>
          <a
            href="http://razorpay.com/"
            target="_blank"
            class="razorpay-logo"
            rel="noreferrer noopener"
          >
            <img
              alt="razorpay-logo"
              src="https://images.poshvine.com/razorpay/razorpay_blue_logo.svg"
              class="razorpay-logo pv-ml-7px md:pv-ml-5px"
            />
          </a>
          <div class="separator mar-top-3"></div>
          <img
            src="assets/pci-dss-compliant.png"
            alt=""
            class="mar-top-2"
            style="height: 14px"
          />
        </div>
      </div>
    </div>
  </div>
</footer>
